import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import { ActionsMenu } from 'domains/MediaPlatforms/Assets/Asset'
import { useMediaAssetUpdateMutation } from 'hooks/mutations/media/MediaAsset'
import {
  mediaPlatformAssetRawRoute,
  mediaPlatformAssetRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets/Asset/Routing'
import { mediaAssetQueryKeys } from 'services/queryKeys/media'

const StructureRaw = () => {
  const { t } = useTranslation(['pages', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { assetId } = mediaPlatformAssetRoute.useParams()

  const assetQuery = useQuery(mediaAssetQueryKeys.detail({ assetId }))

  const { mutate, ...assetUpdateMutation } = useMediaAssetUpdateMutation()

  const handleUpdate = useCallback(
    (title: string, closeCallback: () => void) => {
      mutate(
        {
          assetId,
          mediaAssetEdit: { name: title },
        },
        {
          onError: () => enqueueSnackbar(t('pages:MediaOTT.updateError')),
          onSettled: closeCallback,
        },
      )
    },
    [mutate, assetId, enqueueSnackbar, t],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={assetQuery.data?.name ?? ''}
          isLoading={assetQuery.isLoading}
          isSaving={assetUpdateMutation.isPending}
          onSave={handleUpdate}
          Actions={<ActionsMenu />}
        />
      }
      SubNavigation={
        <Tabs>
          <NavigationTabLink from={mediaPlatformAssetRoute.to} to={mediaPlatformAssetRawRoute.to}>
            {t('pages:MediaOTT.mediaPlatform.config')}
          </NavigationTabLink>
        </Tabs>
      }
    />
  )
}

export const Structure = memo(StructureRaw)
